module.exports = __webpack_public_path__ + "img/aiLogo.7dd8b465.png";